export default __webpack_public_path__ + "static/media/backArrow.309a7c90.svg";